import React from "react";
import JobHeader from "./JobHeader";
import JobTabs from "./JobTabs";

function JobAddList() {
  return (
    <div className="w-full h-full overflow-y-scroll">
      <JobHeader />
      <div className="white_card mt-[2.5rem] flex-1 min-h-[55vh]">
        <div className="mb-[1.5rem] text-[#000] text-[1.125rem] font-[500] font-dmSans">
          Job Details
        </div>
        <JobTabs />
      </div>
    </div>
  );
}

export default JobAddList;
